import { getCmsJourneyPlannerStation } from "../../../app/api/getCmsJourneyPlannerStation";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, ICmsNetworkMapStations, ICmsStationResponse } from "../../../Orchestrator/Types/Index";

class GetCmsJourneyPlannerStationAction extends BaseAction<ICmsNetworkMapStations[], void> {
  override async run(): Promise<ICmsNetworkMapStations[] | null> {
    let listOfData: ICmsNetworkMapStations[] = [];
    try {
      const response: IApiResponse<ICmsStationResponse> = await getCmsJourneyPlannerStation();
      if (response.status === "ok" && response.answer) {
        const data = response.answer.data;
        if (data.length > 0) {
          listOfData = data
        } else {
          console.warn("No data available.");
        }
      } else {
        console.warn("Failed to fetch data.");
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      updateRecoilState("journeyPlannerStationAtom", listOfData);
      return listOfData;
    }
  }
}

export const getCmsJourneyPlannerStationAction = new GetCmsJourneyPlannerStationAction()
